import { render, staticRenderFns } from "./2.vue?vue&type=template&id=84450e14&"
import script from "./2.vue?vue&type=script&lang=js&"
export * from "./2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84450e14')) {
      api.createRecord('84450e14', component.options)
    } else {
      api.reload('84450e14', component.options)
    }
    module.hot.accept("./2.vue?vue&type=template&id=84450e14&", function () {
      api.rerender('84450e14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/KeyPlan/Steps/2.vue"
export default component.exports